export const theme = {
    color: {
     darknest: "#000000",
     dark: "#14213d",
     middle: "#fca311",
     light: "#e5e5e5",
     lighter: "#FFFFFF",
    },
    breakpoint: {
        extraSmall: "360px",
        xs: "420px",
        s: "991px",
        m: '1300px',
    }
 };